"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Modal = _interopRequireDefault(require("../Modal"));
var _constants = require("../Modal/constants");
var _Button = _interopRequireDefault(require("../ui/Button"));
var _modalStyles = _interopRequireDefault(require("../collections/components/modalStyles.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ConfirmModal = function ConfirmModal(_ref) {
  var header = _ref.header,
    onClose = _ref.onClose,
    confirmButton = _ref.confirmButton,
    confirmButtonText = _ref.confirmButtonText,
    cancelButtonText = _ref.cancelButtonText,
    cancelButton = _ref.cancelButton,
    content = _ref.content,
    size = _ref.size;
  var _useTranslation = (0, _reactI18next.useTranslation)('CONFIRM_MODAL'),
    t = _useTranslation.t;
  var onConfirmHandler = (0, _react.useCallback)(function () {
    return onClose(true);
  }, [onClose]);
  var onCancelHandler = (0, _react.useCallback)(function () {
    return onClose(false);
  }, [onClose]);
  var onCloseHandler = function onCloseHandler() {
    return onClose(null);
  };
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    centered: true,
    closeIcon: true,
    className: !size ? _modalStyles.default.collectionsModal : undefined,
    size: size,
    onClose: onCloseHandler
  }, header && /*#__PURE__*/_react.default.createElement(_Modal.default.Header, {
    className: _modalStyles.default.header
  }, header), /*#__PURE__*/_react.default.createElement(_Modal.default.Content, {
    className: _modalStyles.default.content
  }, content && /*#__PURE__*/_react.default.createElement("div", {
    className: _modalStyles.default.text
  }, content), confirmButton && ((0, _react.isValidElement)(confirmButton) ? (0, _react.cloneElement)(confirmButton, {
    onClick: onConfirmHandler
  }) : (0, _react.cloneElement)(/*#__PURE__*/_react.default.createElement(_Button.default, null), {
    onClick: onConfirmHandler,
    children: confirmButtonText || t('APPROVE_BUTTON')
  })), cancelButton && ((0, _react.isValidElement)(cancelButton) ? (0, _react.cloneElement)(cancelButton, {
    onClick: onCancelHandler
  }) : (0, _react.cloneElement)(/*#__PURE__*/_react.default.createElement(_Button.default, null), {
    onClick: onCancelHandler,
    children: cancelButtonText || t('CANCEL_BUTTON')
  }))));
};
ConfirmModal.propTypes = {
  onClose: _propTypes.default.func.isRequired,
  cancelButton: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.bool]),
  cancelButtonText: _propTypes.default.string,
  confirmButton: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.bool]),
  confirmButtonText: _propTypes.default.string,
  content: _propTypes.default.any,
  header: _propTypes.default.node,
  size: _propTypes.default.oneOf(Object.values(_constants.SIZES))
};
ConfirmModal.defaultProps = {
  onClose: function onClose() {
    return undefined;
  },
  cancelButton: true,
  confirmButton: true
};
var _default = exports.default = (0, _react.memo)(ConfirmModal);